import React from 'react';
import { motion } from 'framer-motion';
import { Key, Home, Briefcase } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Administración de Lujo',
    description: 'Gestión integral de propiedades de alto valor, asegurando mantenimiento impecable y atención personalizada.',
    icon: Home,
    image: 'https://images.unsplash.com/photo-1613977257363-707ba9348227?auto=format&fit=crop&w=1170&q=80'
  }, {
    title: 'Compraventa Estratégica',
    description: 'Asesoría experta para adquirir o vender propiedades premium en las zonas más exclusivas de la Riviera Maya.',
    icon: Briefcase,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1170&q=80'
  }, {
    title: 'Gestión de Rentas Premium',
    description: 'Maximización de ingresos a través de plataformas selectas y perfiles de inquilinos rigurosamente evaluados.',
    icon: Key,
    image: 'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=1170&q=80'
  }];
  return <section id="servicios" className="py-24 bg-white" data-id="element-217">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-8" data-id="element-219">
          <div className="max-w-2xl" data-id="element-220">
            <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-221">
              Nuestros Servicios
            </span>
            <h2 className="text-4xl md:text-5xl font-playfair text-charcoal leading-tight" data-id="element-222">
              Soluciones Inmobiliarias de{' '}
              <span className="italic text-gold" data-id="element-223">Alto Nivel</span>
            </h2>
          </div>
          <p className="text-charcoal/70 max-w-md text-sm md:text-base leading-relaxed" data-id="element-224">
            Diseñamos estrategias a medida para proteger y multiplicar el valor
            de su patrimonio en el Caribe Mexicano.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-225">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="group relative h-[450px] rounded-2xl overflow-hidden cursor-pointer" data-id="element-226">
              {/* Background Image */}
              <div className="absolute inset-0 w-full h-full" data-id="element-227">
                <div className="absolute inset-0 bg-charcoal/40 group-hover:bg-charcoal/20 transition-colors duration-500 z-10" data-id="element-228" />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 via-charcoal/40 to-transparent z-10" data-id="element-229" />
                <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out" data-id="element-230" />
              </div>

              {/* Content */}
              <div className="absolute inset-0 z-20 p-8 flex flex-col justify-end" data-id="element-231">
                <div className="w-12 h-12 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center mb-6 border border-white/30 group-hover:bg-gold group-hover:border-gold transition-all duration-300 transform group-hover:-translate-y-2" data-id="element-232">
                  <service.icon className="text-white" size={24} strokeWidth={1.5} data-id="element-233" />
                </div>

                <h3 className="text-2xl font-playfair font-semibold text-white mb-3 transform group-hover:-translate-y-2 transition-transform duration-300" data-id="element-234">
                  {service.title}
                </h3>

                <p className="text-white/80 text-sm leading-relaxed opacity-0 group-hover:opacity-100 transform translate-y-4 group-hover:-translate-y-2 transition-all duration-300 delay-100" data-id="element-235">
                  {service.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}